let retValue = "";

export const  generateUUID = () => {
    // @ts-ignore
    const cryptoObj = window.crypto || window.msCrypto; // Podpora i pro starší IE s `msCrypto`

    const date = new Date();
    if (cryptoObj && cryptoObj.getRandomValues) {
        // Bezpečné generování UUID s `crypto.getRandomValues`
        return retValue = '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) => {
            const random = cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15;
            const value = parseInt(c, 16) ^ (random >> (parseInt(c) / 4));
            return value.toString(16);
        }) + '-' + date.getTime();
    } else {
        // Záložní metoda pro starší prohlížeče
        return retValue = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        }) + '-' + date.getTime();
    }
}

export const IsMobile = () => {
    const bottomPlayer = document.getElementById("player-bottom");
    return   (bottomPlayer?.offsetWidth || 0) < 10;
}

